var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{staticClass:"ArrowAsBack",attrs:{"width":"61","height":"50","viewBox":"0 0 61 50","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M14 12C14 12 6.78324 19.2045 2 24.0345L13.9991 36","stroke":"black","stroke-width":"2.6"}}),_vm._v(" "),_c('path',{attrs:{"d":"M60.1265 24H2.12647","stroke":"black","stroke-width":"3"}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b30dd004","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ArrowAsBack.vue
// module id = 118
// module chunks = 0